﻿import common = require("../../../common");
import Vue from 'vue';
import Component from 'vue-class-component'
import HotEditableFormManager = require("./HotEditableFormManager");
import utilities = require("../../utilities");
import config = require("../../config");
import HotEditableHelpers = require("./HotEditableHelpers");

declare function __getHotEditableTextBoxComponentTemplate(): string;


@Component({
    props: {
        initId: String,
        initName: String,
        initClass: String,
        initValue: String,
        initDefaultValue: String,
        initTabIndex: Number,
        initDisplayName: String,
        initRequired: String,
        initDisabled: String,
        initReadonly: Boolean,
        initPlaceholder: String,
        initType: String,
        initCssOptions: String,
        initRows: Number,
        initMaxLength: Number,
        initEditModeOn: Boolean,
        initCanChangeEditMode: Boolean,
        initClearable: Boolean,
        initDisableCopyPaste: Boolean,
        initPattern: String,
        initDisplayFormaterName: String,
        initUnderFieldContent: Object,
        initUnderFieldContents: Array,
    }
})
class HotEditableTextboxComponent extends Vue implements common.IHotEditableFieldComponent {

    initId: string;
    initName: string;
    initClass: string;
    initValue: string;
    initDefaultValue: string;
    initTabIndex: number;
    initDisplayName: string;
    initMaxLength: number;
    initPlaceholder: string;
    initRequired: string;
    initDisabled: string;
    initType: string;
    initCssOptions: string;
    initRows: number;
    initEditModeOn: boolean;
    initCanChangeEditMode: boolean;
    initClearable: boolean;
    initReadonly: boolean;
    initDisableCopyPaste: boolean;
    initPattern: string;
    initDisplayFormaterName: string;
    initUnderFieldContent: common.IHotEditableAdditionalFieldContent;
    initUnderFieldContents: common.IHotEditableAdditionalFieldContent[];

    rootId: string;
    editModeOn: boolean;
    canChangeEditMode: boolean;
    elementValue: string;
    defaultValue: string;
    tabIndex: number;
    required: boolean;
    disabled: boolean;
    readonly: boolean;
    placeholder: string;
    type: string;
    rows: number;
    maxLength: number;
    cssClass: string;
    elementName: string;
    idElement: string;
    displayName?: string;
    clearable: boolean;
    clearableCurrent: boolean;
    disableCopyPaste: boolean;
    cssOptions: string;
    pattern: string;
    hasError: boolean;
    underFieldContents: common.IHotEditableAdditionalFieldContent[];
    fieldType = common.HotEditableFieldTypes.textbox;
    displayFormaterName: string;

    _displayFormater = null as common.ITextFormater;
    _previousValue = null as string;//NOTE: Doit etre NULL (defined) car il est definie dans le "created" (vue)
    _formManagerParent: HotEditableFormManager;//NOTE: Doit undefined initialement car il est definie dans le "beforeCreate" (vue)
    //_disableNextChangedAction = false;//NOTE: Previens le double-changed en provenance du input::blur()

    static textType = {
        /** default: single line */
        text: "text",
        /** multi-lignes */
        textarea: "textarea",
        //other special cases here
    };

    static tagName = "hoteditabletextbox";
    static prepareMarkup(element: HTMLElement) {

        if (!element)
            throw "[" + this.tagName + "::prepareMarkup] L'element est NULL";

        element.removeAttribute("hot-editable");
        element.setAttribute("hot-editable-cloak", "");

        const newOuterHtml = element.outerHTML.replace('<input ', '<' + this.tagName + ' ')
            .replace(' id=', ' init-id=')
            .replace(' name=', ' init-name=')
            .replace(' class=', ' init-class=')
            .replace(' value=', ' init-value=')
            .replace(' default-value=', ' init-default-value=')
            .replace(' required=', ' init-required=')
            .replace(' disabled=', ' init-disabled=')
            .replace(' placeholder=', ' init-placeholder=')
            .replace(' type=', ' init-type=')
            .replace(' css-options=', ' init-css-options=')
            .replace(' rows=', ' v-bind:init-rows=')
            .replace(' display-name=', ' init-display-name=')
            .replace(' clearable=', ' v-bind:init-clearable=')
            .replace(' readonly=', ' v-bind:init-readonly=')
            .replace(' disable-copy-paste=', ' v-bind:init-disable-copy-paste=')
            .replace(' tabindex=', ' v-bind:init-tab-index=')
            .replace(' maxlength=', ' v-bind:init-max-length=')
            .replace(' edit-mode-on=', ' v-bind:init-edit-mode-on=')
            .replace(' can-change-edit-mode=', ' v-bind:init-can-change-edit-mode=')
            .replace(' pattern=', ' init-pattern=')
            .replace(' display-formater-name=', ' init-display-formater-name=')
            .replace(' under-field-content=', ' v-bind:init-under-field-content=')
            .replace(' under-field-contents=', ' v-bind:init-under-field-contents=');

        element.outerHTML = newOuterHtml;
    }

    data() {
        const buildUnderFieldContents = (value: common.IHotEditableAdditionalFieldContent, values: common.IHotEditableAdditionalFieldContent[]) => {
            const a = value;
            const r = values || [] as common.IHotEditableAdditionalFieldContent[];
            if (a && a.value)
                r.push(a);
            return r;
        };

        const guid = utilities.createGuid('N');
        const id = this.initId || "Field_" + guid;
        const typeIsPassword = this.initType === 'password';
        const isClearable = this.initClearable === true;
        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            elementName: this.initName || id,
            editModeOn: this.initEditModeOn === true,
            canChangeEditMode: this.initCanChangeEditMode === true,
            elementValue: this.initValue || '',
            defaultValue: this.initDefaultValue || '',
            tabIndex: this.initTabIndex,
            displayName: this.initDisplayName || null,
            maxLength: this.initMaxLength || 999999,
            required: this.initRequired === 'required',
            disabled: this.initDisabled === 'disabled',
            readonly: this.initReadonly === true,
            placeholder: this.initPlaceholder || '',
            type: this.initType || 'text',//Options: text, search, password, date, number, range, textarea + custom types (custom-integer, custom-money)
            cssOptions: this.initCssOptions || '|none|',
            rows: this.initRows || 2,
            cssClass: this.initClass || '',
            clearable: isClearable,
            clearableCurrent: isClearable,
            disableCopyPaste: typeIsPassword || this.initDisableCopyPaste === true,//<- Default is TRUE for PASSWORD
            hasError: false,
            underFieldContents: buildUnderFieldContents(this.initUnderFieldContent, this.initUnderFieldContents),
            pattern: this.initPattern || '',
            displayFormaterName: this.initDisplayFormaterName || ''
        };
        return o;
    }

    updatePreviousValue(value?: any) {
        this._previousValue = value || value === '' || value === 0 || value === false ? (value as string).trim() : (this.elementValue || '').trim();
        return this;
    }

    changeMode(canChangeEditMode: boolean, editModeOn: boolean) {
        this.updatePreviousValue();
        this.canChangeEditMode = canChangeEditMode;
        this.editModeOn = editModeOn;
    }

    setFromTextualValue(textualValue?: string) {
        textualValue = textualValue || '';

        if (this.elementValue !== textualValue) {
            this.updatePreviousValue();
            this.elementValue = textualValue;
            this.updateClearableCurrent();
        }

        return this;
    }

    getTextualValue() {
        return this.elementValue || '';
    }

    created() {
        if (this.displayFormaterName) {
            const f = config.textFormaters[this.displayFormaterName];
            if (f)
                this._displayFormater = f;
            else
                throw "Le formater '" + this.displayFormaterName + "' n'est pas supporté (config.textFormaters).";
        }
    }

    mounted() {
        HotEditableHelpers.validateFieldSettings(this);

        (this.$el as Element).removeAttribute("hot-editable-cloak");


        this.updatePreviousValue();
        this.updateClearableCurrent();

        // permet de faire fonctionner le blur
        document.addEventListener("mousedown", e => {
            if (!this.canChangeEditMode || !this.editModeOn)
                return;
            const root = this.$refs["root"] as Element;

            if (utilities.isOutside(e.target as Element, root))
                this.onBlur(e);
        });
    }

    beforeCreate() {
        this._formManagerParent = ((this.$parent as any).formManager as HotEditableFormManager).registerField(this);
        this.$options.template = __getHotEditableTextBoxComponentTemplate();
    }

    getFormatedDisplay() {
        const value = this._displayFormater
            ? this._displayFormater.format(this.elementValue)
            : this.elementValue;

        return utilities.replaceLineBreakByBrTag(value);
    }

    isClearable() {
        return this.clearable && this.clearableCurrent;
    }

    private updateClearableCurrent() {
        this.clearableCurrent = !!this.elementValue;
    }

    editClick(event?: Event, forcedMode?: boolean) {
        if (!this.canChangeEditMode)
            return;

        this.updatePreviousValue();

        if (forcedMode === true || forcedMode === false) {
            this.editModeOn = forcedMode;
        } else {
            //toggle
            this.editModeOn = !this.editModeOn;
        }

        if (this.editModeOn)
            this.updateClearableCurrent();

        this._formManagerParent.editModeChanged(this);

        this.focus();
    }

    onEnterClick(event?: KeyboardEvent) {
        if (this.type === 'textarea')
            return;

        //if (this.canChangeEditMode)//NOTE: Ne jamais poster le form au 'Enter' click.
        this.preventDefault(event);

        this.changed();
    }

    onEscapeClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);

        this.cancel();
    }

    onTabClick(event?: KeyboardEvent) {
        //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
        if (event.shiftKey) {
            this.onShiftTabClick(event);
            return;
        }

        this.focusNextComponent();

        if (this.canChangeEditMode)
            this.preventDefault(event);
    }

    onShiftTabClick(event?: KeyboardEvent) {
        //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
        this.focusNextComponent(true);

        if (this.canChangeEditMode)
            this.preventDefault(event);
    }

    private preventDefault(e?: Event, bypassStopPropagation?: boolean) {
        if (!e)
            return;

        e.preventDefault();

        if (bypassStopPropagation !== true)
            e.stopPropagation();
    }

    private focusNextComponent(getPrevious?: boolean) {
        getPrevious = getPrevious === true;

        if (!this.canChangeEditMode)
            return false;

        this.changed();
        this.editClick(null, false);

        if (getPrevious)
            this._formManagerParent.focusPreviousComponentFromField(this)
        else
            this._formManagerParent.focusNextComponentFromField(this);
    }

    onChanged(event: Event) {
        this.preventDefault(event);
        this.changed();
    }

    onCancel(event: Event) {
        this.preventDefault(event);
        this.cancel();
    }

    onClear(event: Event) {
        this.preventDefault(event);
        this.clear();
    }

    clear() {
        this.updatePreviousValue();
        this.elementValue = "";
        this.$nextTick(() => {
            this.changed();
        });
    }

    changed() {
        this.updateClearableCurrent();

        if (this.canChangeEditMode) {
            this.editModeOn = false;
            this._formManagerParent.editModeChanged(this);

            if ((this.elementValue || '').trim() === this._previousValue)
                return;
        }

        this._formManagerParent.fieldChanged(this);
    }
    cancel() {
        if (!this.canChangeEditMode)
            return;

        this.elementValue = this._previousValue;

        this.editModeOn = false;

        //NOTE: Le "blur()" va lancer le "changed()"
        //this.$root.$emit('hotEditableTextbox-editModeChanged', this);
    }

    onBlur(event?: Event) {
        this.blur();
    }

    onDeleteClick(event?: KeyboardEvent) {

        if (this.editModeOn && !this.canChangeEditMode)
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.changed();
                });
            });
    }

    blur() {
        this.changed();
        //setTimeout(() => { this.changed(true); }, 250);
    }

    focus() {

        this.$nextTick(() => {

            const instance = this.$refs["inputInst"] as HTMLInputElement;
            instance.focus();
        });
    }

    onKeyPressed(event?: KeyboardEvent) {

        if (this.editModeOn && !this.canChangeEditMode)
            this.changed();
    }

    isMultilinesType() {
        return this.type === HotEditableTextboxComponent.textType.textarea;
    }

    // Copy/Paste options
    getCopyPasteOptions(disableCopyPaste?: boolean) {
        const o = disableCopyPaste === true ? '|none|' : '|copy|paste|';
        return o;
    }
    onPaste(event: Event) {
        if (this.disableCopyPaste) {
            this.preventDefault(event, true);
            return false;
        }
    }
    onCopy(event: Event) {
        if (this.disableCopyPaste) {
            this.preventDefault(event, true);
            return false;
        }
    }
    onCut(event: Event) {
        if (this.disableCopyPaste) {
            this.preventDefault(event, true);
            return false;
        }
    }
    onDrag(event: Event) {
        if (this.disableCopyPaste) {
            this.preventDefault(event, true);
            return false;
        }
    }
    onDrop(event: Event) {
        if (this.disableCopyPaste) {
            this.preventDefault(event, true);
            return false;
        }
    }
    onSelectStart(event: Event) {
        if (this.disableCopyPaste) {
            this.preventDefault(event, true);
            return false;
        }
    }
}

export = HotEditableTextboxComponent;